import { interopDefault } from '~/router/utils'

export const Search = () =>
  interopDefault(
    import(
      '~/pages/car/classifieds/search.vue' /* webpackChunkName: "pages-classifieds-search" */
    )
  )

export const MapSearch = () =>
  interopDefault(
    import(
      '~/pages/car/classifieds/map-search.vue' /* webpackChunkName: "pages-classifieds-map-search" */
    )
  )
